module.exports = __webpack_public_path__ + "assets/img/delivery2.ede7b8b7.png";